// @ts-strict-ignore
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProjectFinalizationInfoVO, ProjectVO } from '../../../model/vo/project.vo';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { ModelConversionService } from '@shared/convert/model-conversion.service';
import { ArticleVO } from '@article/model/vo/article.vo';
import { inject, Injectable } from '@angular/core';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';

export interface MarkingSystemSeriesInfo {
  seriesId: number;
  isRecommended: boolean;
  separationRequired: boolean;
}

export interface MarkingSystemArticleInfo {
  markingSystemTypeId: number;
  articleId: number;
  articleNo: string;
  color: string;
  displayName: string;
  seriesInfos: MarkingSystemSeriesInfo[];
}

@Injectable({ providedIn: 'root' })
export class MarkingSystemDataService {

  private readonly modelConversionService = inject(ModelConversionService);
  private readonly wagoApiClient = inject(WagoApiClient);
  private readonly localeResourceManager = inject(LocaleResourceManager);

  public getAllArticles(): Observable<MarkingSystemArticleInfo[]> {
    const locale = this.localeResourceManager.currentLanguage.langKey;
    return this.wagoApiClient
      .get<MarkingSystemArticleInfo[]>(`marking-system/articles/${locale}`, null, { overlayType: null });
  }

  public getRelatedArticles(articleId: number): Observable<ArticleVO[]> {
    return this.wagoApiClient.get(`marking-system/article/related/search/article/${articleId}`).pipe(
      map((response: any[]) => this.modelConversionService.convertArticleVOs(response)));
  }

  public searchDuplicateArticleNumberForMarkingSystem(project: ProjectVO): Observable<ProjectFinalizationInfoVO> {
    return this.wagoApiClient.post(`marking-system/article/duplicate/number`, project).pipe(
      map((response) => this.modelConversionService.convertProjectFinalizationInfoVO(response)));
  }

  public loadFinalizationInfoForSeriesNumber(seriesNumber: number): Observable<ProjectFinalizationInfoVO> {
    return this.wagoApiClient.get(`marking-system/${seriesNumber}/project-finalization-info`).pipe(
      map((response) => this.modelConversionService.convertProjectFinalizationInfoVO(response)));
  }
}
